import * as React from "react"
import { Modal, FormField, Form, Dropdown, Checkbox } from "semantic-ui-react";
import Button from "@material-ui/core/Button";
import ConselhosPermitidos from "./conselho/ConselhosPermitidos";
import EstadosBrasil from "./conselho/EstadosBrasil";
import { postProfissionalSolicitante } from "@store/actions";
import AjaxLoader from "../shared/ajax_loader";
import m from "@utils/strings";

interface IInclusaoProfissionalProps {
    callSnackbar: (msg: string, type: string) => void,
    retornoListagem: (lista: any, nomeNovoProfissional: string) => void
}

interface IInclusaoProfissionalState {
    modalOpen: boolean,
    nome: string,
    conselho: string,
    numeroConselho: string,
    estado: string,
    loading: boolean,
    marcarComoProfissionalSolicitante: boolean
}

const INITIAL_STATE: IInclusaoProfissionalState = {
    modalOpen: false,
    nome: '',
    conselho: '',
    numeroConselho: '',
    estado: '',
    loading: false,
    marcarComoProfissionalSolicitante: true
}

const maxLengthNumeroConselho: number = 20;

export default class InclusaoProfissional extends React.Component<IInclusaoProfissionalProps, IInclusaoProfissionalState>{
    constructor(props: any){
        super(props);
  
        this.state = {
            ...INITIAL_STATE
        }
    }

    conselhos = ConselhosPermitidos.map(m => ({ key: ConselhosPermitidos.indexOf(m) + 1, text: m.nome, value: m.sigla }));
    estados = EstadosBrasil.map(m => ({ key: EstadosBrasil.indexOf(m) + 1, text: m.nome, value: m.sigla }));

    public handleOpen = () => this.setState({ modalOpen: true });
    public handleClose = () => this.zerarState(false);

    public zerarState = (modalOpen: boolean = true) => {
        this.setState({
            ...INITIAL_STATE,
            modalOpen: modalOpen
        });
    }

    public handleSave = () => {
        this.setState({ loading: true });

        const params = {
            Nome: this.state.nome.replace("Dr(a)", "").trimStart(),
            Conselho: this.state.conselho,
            Estado: this.state.estado,
            NumeroConselho: this.state.numeroConselho
        };

        postProfissionalSolicitante(
            params,
            (result: any) => {
                this.props.callSnackbar(
                    m.TELA_INCLUSAO_PROFISSIONAL.NOTIFICACAO_PROFISSIONAL_SALVO_SUCESSO,
                    "success"
                );

                this.props.retornoListagem(
                    result,
                    (
                        this.state.marcarComoProfissionalSolicitante
                            ? params.Nome
                            : ""
                    )
                );

                this.zerarState(
                    !this.state.marcarComoProfissionalSolicitante
                );
            },
            (error: any) => {
                this.setState({ loading: false });

                this.props.callSnackbar(
                    `${m.TELA_INCLUSAO_PROFISSIONAL.NOTIFICACAO_PROFISSIONAL_ERRO_SALVAR} [${error?.response?.data}]`,
                    "error"
                );
            }
        );
    }

    public onChangeNome = (element: any) =>{
        let auxNome = element.target.value;

        if(!element.target.value.startsWith("Dr(a)"))
            auxNome = `Dr(a) ${auxNome}`;

        this.setState({
            nome: auxNome
        });
    }

    public onChangeConselho = (ev: any, element: any) =>{
        this.setState({ conselho: element.value });
    }

    public onChangeNumeroConselho = (element: any) =>{
        let auxNumeroConselho = element.target.value;

        if(auxNumeroConselho.length > maxLengthNumeroConselho)
            auxNumeroConselho = auxNumeroConselho.substring(0, maxLengthNumeroConselho);

        this.setState({ numeroConselho: auxNumeroConselho });
    }

    public onChangeEstado = (ev: any, element: any) =>{
        this.setState({ estado: element.value });
    }

    public render(){

        const loadingSave = this.state.loading
            ? ( <AjaxLoader ajaxMessage={m.TELA_INCLUSAO_PROFISSIONAL.NOTIFICACAO_PROFISSIONAL_SALVANDO_AGUARDE} /> )
            : ( "" );

        return(
            <div>
                <Modal
                    open={this.state.modalOpen}
                    onClose={this.handleClose}
                    centered={true}
                    trigger={
                        <Button
                            title={m.TELA_INCLUSAO_PROFISSIONAL.LABEL_CRIAR_NOVO_PROFISSIONAL}
                            onClick={this.handleOpen}
                            className="btn-form"
                            style={{ width: "40px", minWidth: "40px" }}
                        >+
                        </Button>
                    }
                    size="small"
                    style={{ height: "460px", position: "relative" }}
                     >
                    <Modal.Header>{m.TELA_INCLUSAO_PROFISSIONAL.HEADER_INCLUSAO_PROFISIONAL_SAUDE}</Modal.Header>
                    <Modal.Content>
                        <div>
                            {loadingSave}
                            <Form>
                                <Form.Group>
                                    {/* <Form.Field inline={true} width={1} style={{ marginTop: "30px" }}>
                                        <div>
                                            <label className={"form-autorizacao-label"}>Dr(a)</label>
                                        </div>
                                    </Form.Field> */}
                                    <FormField width={10}>
                                        <div>
                                            <label className={"form-autorizacao-label"}>{m.TELA_INCLUSAO_PROFISSIONAL.LABEL_DIGITE_NOME}</label>
                                        </div>
                                        <input 
                                            type='text'
                                            placeholder='Nome Dr(a)'
                                            value={this.state.nome}
                                            onChange={this.onChangeNome}
                                        />
                                    </FormField>
                                    <Form.Field width={5}>
                                        <div>
                                            <label className={"form-autorizacao-label"}>{m.TELA_INCLUSAO_PROFISSIONAL.LABEL_DIGITE_CR}</label>
                                        </div>
                                        <input
                                            placeholder='Número C.R.'
                                            value={this.state.numeroConselho}
                                            type="number"
                                            maxLength={maxLengthNumeroConselho}
                                            onChange={this.onChangeNumeroConselho}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths='equal' style={{ marginTop: "25px" }}>
                                    <Form.Field >
                                        <div>
                                            <label className={"form-autorizacao-label"}>{m.TELA_INCLUSAO_PROFISSIONAL.LABEL_SELECIONTE_CR}</label>
                                        </div>
                                        <Dropdown
                                            placeholder="Conselho"
                                            search
                                            selection
                                            options={this.conselhos}
                                            value={this.state.conselho}
                                            onChange={this.onChangeConselho}
                                        />
                                    </Form.Field>
                                    <Form.Field >
                                        <div>
                                            <label className={"form-autorizacao-label"}>{m.TELA_INCLUSAO_PROFISSIONAL.LABEL_SELECIONE_ESTADO}</label>
                                        </div>
                                        <Dropdown
                                            placeholder="Estado"
                                            search
                                            selection
                                            options={this.estados}
                                            value={this.state.estado}
                                            onChange={this.onChangeEstado}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Field >
                                    <Checkbox
                                        checked={this.state.marcarComoProfissionalSolicitante}
                                        onChange={() =>{
                                            this.setState({
                                                marcarComoProfissionalSolicitante: !this.state.marcarComoProfissionalSolicitante
                                            })
                                        }}
                                        label='Retornar como profissional solicitante'
                                        />
                                </Form.Field>
                            </Form>
                        </div>
                    </Modal.Content>
                    <Modal.Actions style={{ position: "absolute", bottom: "0rem", width: "100%" }}>
                        <Button onClick={this.handleClose} style={{ marginRight: "30px" }}>{m.TELA_INCLUSAO_PROFISSIONAL.BUTTON_FECHAR}</Button>
                        <Button onClick={this.handleSave} className="btn-form" style={{ width: "90px" }}>{m.TELA_INCLUSAO_PROFISSIONAL.BUTTON_SALVAR}</Button>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}